var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutsidePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.4 332.8V384H332.8v307.2H640V537.6h51.2v204.8H281.6V332.8h204.8zm76.8-51.2h179.2v179.2h-51.2v-128h-128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M440.32 542.72l256-256 40.96 40.96-256 256z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsidePage);
export default __webpack_public_path__ + "static/media/outside-page.6fcbb7bc168e4772038d403ba8f96afe.svg";
export { ForwardRef as ReactComponent };